export default __webpack_public_path__ + "static/media/taqn.0ac5c132.png";